import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";

const GPFNRWork = () => {
  const userId = localStorage.getItem("userId");
  const [GPFNRData, setGPFNRData] = useState([]);
  const getGPFNRData = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-gpfnr-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        setGPFNRData(result.result);
      } else {
        setGPFNRData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getGPFNRData();
  }, [userId]);

  return (
    <div className="container py-3">
      <div className="all-itc-data">
        <div className="row align-items-center mb-3">
          <div className="col-lg-2">
            <Link
              className="btn btn-sm btn-danger"
              to={"/dashboard/gpf_non_refundable"}
            >
              Back
            </Link>
          </div>
          <div className="col-lg-10">
            <h1 className="text-center display-6 fw-bold text-red-500">
              All Completed Data
            </h1>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="table-responsive  overflow-x-auto">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Office Name</th>
                    <th scope="col">Designation</th>
                    <th scope="col">GPF No.</th>
                    <th scope="col">Mobile</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {GPFNRData &&
                    GPFNRData.map((item, index) => {
                      return (
                        <tr>
                          <th scope="row">{index + 1}</th>
                          <td>{item.empName}</td>
                          <td>{item.officeName}</td>
                          <td>{item.empDesignation}</td>
                          <td>{item.gpfNumber}</td>
                          <td>{item.empMobile}</td>

                          <td>
                            <Link
                              to={`/dashboard/edit_gpfnrwork_table/${item._id}`}
                              className="btn btn-primary btn-sm ms-1"
                            >
                              <i className="fa fa-edit"></i>Edit
                            </Link>
                            <Link
                              to={`/dashboard/print_gpfnrwork_table/${item._id}`}
                              className="btn btn-success   btn-sm ms-1"
                            >
                              <i className="fa fa-print"></i>Print
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GPFNRWork;
